import { useEffect, useMemo, useState } from "react";

function formatTimeInZone(date: Date, timeZone: string): string {
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  } catch {
    return new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  }
}

/** Hora ao vivo para o rodapé editorial (fuso IANA configurável em `site.footer`). */
export function useFooterClock(timeZone: string) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return useMemo(() => formatTimeInZone(now, timeZone), [now, timeZone]);
}
